import { lazy } from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import ProtectedAuthRoute from "./ProtecredAuthRoute";

const Main = lazy(() => import("../pages/Main"));
const Login = lazy(() => import("../pages/Login"));
const Register = lazy(() => import("../pages/Register"));
const Recovery = lazy(() => import("../pages/Recovery"));
const Dashboard = lazy(() => import("../pages/Dashboard"));
const Company = lazy(() => import("../pages/Company"));
const Products = lazy(() => import("../pages/Products"));
const ProductsImport = lazy(() => import("../pages/Products/ProductsImport"));
const Bills = lazy(() => import("../pages/Bills"));
const Referal = lazy(() => import("../pages/Referal"));
const Profile = lazy(() => import("../pages/Profile"));
const TopUp = lazy(() => import("../pages/TopUp"));
const ProductsDetail = lazy(() => import("../pages/ProductDetail"));
const Notifications = lazy(() => import("../pages/Notification"));
const Verification = lazy(() => import("../pages/Verification"));
const VerificationRecovery = lazy(() => import("../pages/VerificationRecovery"));
const QrPreview = lazy(() => import("../pages/QrPreview"));

const routes = [
  {
    path: "/home",
    element: (
        <ProtectedRoute>
          <Main />
        </ProtectedRoute>
    ),
    children: [
      {
        path: '/home/dashboard',
        element: <Dashboard />
      },
      {
        path: '/home/products',
        element: <Products />
      },
      {
        path: '/home/products/import',
        element: <ProductsImport />
      },
      {
        path: '/home/products/import/:preflightId',
        element: <ProductsImport />
      },
      {
        path: '/home/company',
        element: <Company />
      },
      {
        path: '/home/bills',
        element: <Bills />
      },
      {
        path: '/home/referal',
        element: <Referal />
      },
      {
        path: '/home/profile/password',
        element: <Profile />
      },
      {
        path: '/home/profile',
        element: <Profile />
      },
      {
        path: '/home/top-up',
        element: <TopUp />
      },
      {
        path: '/home/products/:id',
        element: <ProductsDetail />
      },
      {
        path: '/home/notifications',
        element: <Notifications />
      }
    ]
  },
  {
    path: "/",
    element: <ProtectedAuthRoute><Navigate to="/sign-in" /></ProtectedAuthRoute>,
  },
  {
    path: "/sign-in",
    element: <ProtectedAuthRoute><Login /></ProtectedAuthRoute>,
  },
  {
    path: "/sign-up",
    element: <ProtectedAuthRoute><Register /></ProtectedAuthRoute>,
  },
  {
    path: "/verification/sign-up",
    element: <ProtectedAuthRoute><Verification /></ProtectedAuthRoute>,
  },
  {
    path: "/verification/recovery",
    element: <ProtectedAuthRoute><VerificationRecovery /></ProtectedAuthRoute>,
  },
  {
    path: "/recovery",
    element: <ProtectedAuthRoute><Recovery /></ProtectedAuthRoute>,
  },
  {
    path: "/qr-preview/:id",
    element: <QrPreview/>
  }
]

const router = createBrowserRouter(routes);

export default router;
